import React, { useEffect } from "react";
import { setAuthToken } from "../lib/apiService";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear authentication
    setAuthToken(null);
    localStorage.removeItem("user");
    
    // Navigate to login
    navigate("/login");
  }, [navigate]);

  return <div>Logging out...</div>;
}
